// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__RGt3O","content":"Layout_content__wqJiP","container":"Layout_container__Vl9P4","showSidebarButton":"Layout_showSidebarButton__QeFSc"};